export const LOAD_CART_NONCART_PAGE = "Add to cart: load cart contents";
export const LOAD_CART_NONCART_PAGE_START = "Add to cart: Start loading cart contents";
export const ADD_QTY = "Add to cart: add quantity of a product";
